<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">

    <template #cell(deliverables)="data" class="w-50 p-0">
      <span class="text-wrap p-0">
      {{ data.item.deliverables.name }} ({{  modelFaName[data.item.deliverables_type]   }})
      </span>
    </template>

    <template #cell(price)="data">
      {{formatNumber(data.item.price)}}
    </template>


    <template #cell(percent_per_item)="data">
      {{data.item.percent_per_item}}
    </template>

    <template #cell(priority)="data">
      {{data.item.priority}}
    </template>

    <template #cell(action)="data">

      <div  >

         <span class="h4" v-b-tooltip.hover title="حذف">
        <b-icon icon="trash" class="m-3" @click="deleteItem(data.item)"></b-icon>
      </span>

        <span class="h4" v-b-tooltip.hover title="ویرایش">
        <router-link
            :to="{ name: 'UpdateDelivery', params: { id: data.item.id } }"
        >
          <b-icon icon="pencil" class="m-3 text-dark "></b-icon>
        </router-link>
      </span>

      </div>


    </template>
  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItems",
  props: ["items"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "deliverables", label: "ایتم"},
        {key: "price", label: "قیمت"},
        {key: "percent_per_item", label: "درصد"},
        {key: "priority", label: "اولویت"},
        {key: "action", label: ""},
      ],
      modelFaName:{
        category:'دسته بندی',
        brand:'برند',
      }
    };
  },
  methods: {
    formatNumber,
    deleteItem(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch("Delivery/deleteDelivery", item);
      }
    },
    restore(item) {
      if (confirm(' بازگردانی  شود؟')) {
        this.$store.dispatch("Content/restoreContent", item.id);
      }
    },
    forceDeleteContent(item) {
      if (confirm('آیا از حذف  دائمی اطمینان دارید؟')) {
        this.$store.dispatch("Content/forceDeleteContent", item);
      }
    },
  },
};
</script>